import { useTranslation } from 'react-i18next';
import { RotateCcw } from 'lucide-react';

/** Title + subtitle and the (conditional) "reset custom durations" button. */
export function GanttHeader({ months, totalWeeks, hasCustom, onReset }) {
  const { t } = useTranslation();
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <div>
        <h2
          className="text-xl font-semibold text-[#171A1D]"
          style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
          data-testid="gantt-heading"
        >
          {t('gantt.title', 'Implementation Roadmap')}
        </h2>
        <p className="text-sm text-[#66707A] mt-1">
          {t('gantt.subtitle', {
            months,
            weeks: totalWeeks,
            defaultValue: '{{months}}-month visual timeline ({{weeks}} weeks total)',
          })}
        </p>
      </div>
      {hasCustom && (
        <button
          onClick={onReset}
          className="shrink-0 flex items-center gap-1.5 text-xs text-[#66707A] hover:text-[#171A1D] border border-[#DDE1E5] bg-white rounded-lg px-3 py-1.5 transition-colors shadow-sm"
          data-testid="gantt-reset-btn"
        >
          <RotateCcw className="w-3 h-3" /> {t('gantt.reset')}
        </button>
      )}
    </div>
  );
}
